<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="其他功能" CMname="广告信息管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="140px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="广告标题：" prop="adTitle">
                        <el-input v-model="form.adTitle" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.adTitle}}
                        </span>
                    </el-form-item>
                    <el-form-item label="广告内容：" prop="adContent">
                        <el-input v-model="form.adContent" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.adContent}}
                        </span>
                    </el-form-item>
                    <el-form-item label="广告商名称：" prop="advertiserId">
                            <el-select v-model="form.advertiserId" placeholder="请选择" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in advertiser" 
							:key="item.advertiserId"
							:label="item.companyName" 
							:value="item.advertiserId">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.advertiserName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="校验类型：" prop="adType">
                            <el-select v-model="form.adType" placeholder="请选择" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in adTypeData" 
							:key="item.value"
							:label="item.value" 
							:value="item.value">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.adType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="广告描述：" prop="adDesc">
                        <el-input v-model="form.adDesc" v-if="isAdd||isEdit" type="textarea" :rows="3"></el-input>
                        <span v-if="isView">
                            {{form.adDesc}}
                        </span>
                    </el-form-item>

                    <el-form-item label="投放时间：" prop="launchTime">
                             <el-date-picker
                            v-model="launchTime"
                            v-if="isAdd||isEdit"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="选择开始时间"
                            end-placeholder="选择结束时间"
                            value-format="yyyy-MM-dd"
                            @change="getMyDateTime">
                            </el-date-picker>
                        <span v-if="isView">
                            {{form.startDate}} 至 {{form.endDate}}
                        </span>
                    </el-form-item>
                    <el-form-item label="安装人：" prop="installerName">
                        <el-input v-model="form.installerName" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.installerName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="安装人联系方式：" prop="installerTel">
                        <el-input v-model="form.installerTel" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.installerTel}}
                        </span>
                    </el-form-item>
                    <el-form-item label="安装时间：" prop="installerTime" >
                         <el-date-picker
                            v-model="form.installerTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择安装时间"
                            v-if="isAdd||isEdit"
                            >
                            </el-date-picker>
                        <span v-if="isView">
                            {{form.installerTime}}
                        </span>
                    </el-form-item>

                    <!-- <el-form-item label="站点名称：" prop="siteId">
                            <el-select v-model="form.siteId" @change="changeSiteId" placeholder="请选择" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in siteidData" 
							:key="item.SiteId"
							:label="item.SiteName" 
							:value="item.SiteId">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="灯箱名称：" prop="lightBoxId">
                            <el-select v-model="form.lightBoxId" @change="changeLightBoxId" placeholder="请选择" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in adLightBox" 
                            :key="item.lightBoxId"
							:label="item.lightBoxName" 
							:value="item.lightBoxId">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.lightBoxName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="设备名称：" prop="deviceId">
                            <el-select v-model="form.deviceId" placeholder="请选择" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in adDeviceId" 
							:key="item.deviceId"
							:label="item.deviceName" 
							:value="item.deviceId">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.deviceName}}
                        </span>
                    </el-form-item> -->

                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1" :disabled="isView">启用</el-radio>
                            <el-radio :label="0" :disabled="isView">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="图片上传：" prop="adPicUrl">
                        <el-upload
                            class="avatar-uploader"
                            :action="baseURL"
                            v-if="isAdd||isEdit" 
                            accept=".jpg,.png,.gif"
                            :headers="headers"
                            :show-file-list="false"
                            :with-credentials="true"
                            :data="extraData"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <img v-if="isView" :src="imageUrl" class="avatar">
                        </el-form-item>
                    </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'ADdetail',
    data() {
        return {
            form: {
                adId: 0,
                adTitle:"",
                adContent:"",
                adDesc:"",
                adType:"",
                adPicUrl:"",
				startDate:"",
                endDate:"",
                advertiserId:"",
				installerName:"",
				installerTel:"",
                installerTime:"",
                // lightBoxId:"",
                deviceId:"",
                // siteId:"",
                status: 1,
                // lightBoxName:"",
                // deviceName:"",
            },
            adTypeData: [{
            value: '单校验'
            }, {
            value: '组校验'
            }],
            rules: {
                adTitle: [{ required: true, message: '请输入广告标题',  trigger: 'blur' }],
                adContent:[{ required: true, message: '请输入广告内容',  trigger: 'blur' }],
                adDesc:[{ required: true, message: '请输入广告描述',  trigger: 'blur' }],
				//startDate:[{ required: true, message: '请输入投放开始时间',  trigger: 'blur' }],
                //endDate:[{ required: true, message: '请输入投放结束时间',  trigger: 'blur' }],
                advertiserId:[{ required: true, message: '请输入广告商名称',  trigger: 'change' }],
                adType:[{ required: true, message: '请输入校验类型',  trigger: 'change' }],
				installerName:[{ required: true, message: '请输入安装人',  trigger: 'blur' }],
				installerTel:[{ required: true, message: '请输入安装人联系方式',  trigger: 'blur' }],
                installerTime:[{ required: true, message: '请输入预计安装时间',  trigger: 'blur' }],
                //siteId:[{ required: true, message: '请输入站点名称',  trigger: 'change' }],
                //lightBoxId:[{ required: true, message: '请输入灯箱名称',  trigger: 'change' }],
                deviceId:[{ required: true, message: '请输入设备名称',  trigger: 'change' }],
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
            //siteidData:[],
            advertiser:[],
            //adLightBox:[],
            //adDeviceId:[],
            launchTime:[],
            adLightBoxDefault:0,
            adDeviceIdDefault:"",
            imageUrl: '',
            oldfilename:"",
            baseURL:"",
            headers:{},
            extraData:{},
            //AllOrgListData:[]
        }
    },
    methods: {
        getMyDateTime(val) {
        this.form.startDate=val[0],
        this.form.endDate=val[1]
        },
    //    changeSiteId(val){
    //             this.form.lightBoxId=""
    //             this.form.deviceId=""
    //             this.adLightBoxDefault=val
	// 			this.adLightBoxData();
    //         },
        // changeLightBoxId(val){
        //     this.form.deviceId=""
        //     this.adDeviceIdDefault=val
        //     this.adLightBoxData();
        // },
         handleAvatarSuccess(res, file) {
             this.oldfilename=res.Data
             if(this.oldfilename!=""){
                 this.baseURLData()
             }
        this.$message({
          message: res.Prompt,
          type: 'success'
        });
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||'image/png'||'image/gif';
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG、PNG、GIF 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
      },
       baseURLData(){
            if(this.oldfilename==""){
                this.baseURL=this.$hrraxios.defaults.baseURL+"/api/UpLoad"
            }else if(this.oldfilename!=""){
                if(this.oldfilename.indexOf("/upload/") != -1 ){
                    this.form.adPicUrl=this.oldfilename;
                    var oldfilenameData=this.oldfilename.replace("/upload/","");
                }else{
                    this.form.adPicUrl="/upload/"+this.oldfilename;
                    var oldfilenameData=this.oldfilename.replace("/upload/","");
                }
                this.extraData={oldfilename:oldfilenameData}
                this.baseURL=this.$hrraxios.defaults.baseURL+"/api/UpLoad"
            }
            
        },
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.isAdd ? this.$api.AD.getAD : this.$api.AD.getAD + "/" + this.form.adId;
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: '/AD/info/' });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "广告信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.imageUrl=this.$hrraxios.defaults.baseURL+row.adPicUrl+"?m="+Math.random()
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.launchTime[0]=row.startDate
                this.launchTime[1]=row.endDate
                // this.adLightBoxDefault=row.siteId
                // this.adLightBoxData();
                // this.adDeviceIdDefault=row.lightBoxId
                // this.adLightBoxData();
                this.imageUrl=this.$hrraxios.defaults.baseURL+row.adPicUrl+"?n="+Math.random()
                this.oldfilename=row.adPicUrl
                this.baseURLData()
                this.isEdit = true;
            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var myVuethis = this;
            //所属地铁站
            // this.$hrraxios.get(this.$api.site.downlist)
            //     .then((response) => {
            //         var data = response.data;
            //         if (data.Success == true) {
            //             myVuethis.siteidData = data.Data;
            //         } else {
            //             myVuethis.$message.error("数据初始化失败,请联系管理员");
            //         }
            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     })
        },
        advertiserData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.AD.getAdvertiser)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.advertiser=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
            },
            // adLightBoxData(){
			// 	var Vuethis=this;
			// 	this.$hrraxios.get(this.$api.AD.getAdLightBox+"/"+this.adLightBoxDefault)
			// 	.then(function (response) {
			// 		var data=response.data;
			// 		if(data.Success==true)
			// 		{
            //             var dataSplit=[]
            //             var deviceData=[]
            //             for(var m=0;m<data.Data.length;m++){
            //                 let obj = {
            //                     lightBoxId:data.Data[m].lightBoxId,
            //                     lightBoxName:data.Data[m].lightBoxName
            //                 }
            //                     dataSplit.push(obj);
            //             }
            //             if(Vuethis.adDeviceIdDefault==""){
            //                 let obj = {};
            //                 let siteData = dataSplit.reduce((cur,next) => {
            //                     obj[next.lightBoxId] ? "" : obj[next.lightBoxId] = true && cur.push(next);
            //                     return cur;
            //                 },[])//数组对象去重
            //                   Vuethis.adLightBox=siteData;
            //             }else{
            //                 for(var i=0; i<data.Data.length;i++){
            //                     if(data.Data[i].lightBoxId==Vuethis.adDeviceIdDefault){
            //                         let obj = {
            //                         deviceId:data.Data[i].deviceId,
            //                         deviceName:data.Data[i].deviceName
            //                         }
            //                         deviceData.push(obj);
            //                     }
            //             }
            //             Vuethis.adDeviceId=deviceData;
            //             Vuethis.adDeviceIdDefault=""
            //             }
			// 		}else{
			// 			Vuethis.$message.error(data.Prompt);
			// 		}
			// 	})
			// 	.catch(function (error) {
			// 		console.log(error);
			// 	});
            // },
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.initData();
        this.advertiserData();
        this.headers ={Authorization : 'BasicAuth '+sessionStorage.getItem("access_token")}
        if(this.oldfilename==""){
           this.baseURLData(); 
        }
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 300px;
    height: 178px;
    display: block;
  }
  .el-date-editor .el-range-input{
    background-color:#1E3F6C
}
</style>